import { render, staticRenderFns } from "./logout-button.vue?vue&type=template&id=0bd814a4"
import script from "./logout-button.vue?vue&type=script&lang=js"
export * from "./logout-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports